import { useNavigate } from 'react-router-dom';
import './support.css';
import logo from '../../Assets/images/banner-logo.png'

const SupportPageDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="support-page">
      {/* Header */}
      <header className="support-header">
        <img
          src={logo}
          alt="SDSS Site Inspect Logo"
          className="support-logo"
          onClick={() => navigate('/')}
        />
        <h1>Support</h1>
      </header>

      {/* Main Content */}
      <main className="support-content">
        <p>
          <strong>Site Inspect Support</strong><br />
          This page provides information on how to get help with the Site Inspect
          application, including technical support, guidance, and troubleshooting.
        </p>

        <h2>Getting Help</h2>
        <p>
          If you experience issues using Site Inspect or need assistance, support
          is available through the following channel:
        </p>

        <div className="support-box">
          <h3>📧 Email Support</h3>
          <p>
            For technical issues, access problems, or questions that require
            follow-up, please contact:
          </p>

          <p className="support-email">
            <a href="mailto:support.siteinspect@sdss.net.au">
              support.siteinspect@sdss.net.au
            </a>
          </p>
        </div>

        <h3>Please include the following details:</h3>
        <ul>
          <li>A brief description of the issue</li>
          <li>What you were trying to do when the issue occurred</li>
          <li>Any error messages shown in the app</li>
          <li>Screenshots or photos (if safe and appropriate to share)</li>
        </ul>

        <p className="support-note">
          Providing complete information will help our support team respond more
          quickly.
        </p>
      </main>

      {/* Footer */}
      <footer className="support-footer">
        © 2026 Site Inspect. All rights reserved.
      </footer>
    </div>
  );
};

export default SupportPageDetail;
